
import {get,post} from '@/api/common/index'

/*
    此api为portal首页的api集合
    所有方法返回Promise对象
    这里的接口需要开发
*/

// 获取首页的Banner图片
const getBannerImgs = ()=>{
    return get("/api/portal/get_news_banner_list");
}

// 获取小区
const getCommunityList = (pageIndex,pageSize,qryObj)=>{
    var navQuery = JSON.stringify(qryObj);
    return get("/api/portal/get_community_list_page",{pageIndex,pageSize,navQuery});
}

// 获取街镇
const getStreetTownList = () => {
    return get("/api/public/get_street_town_list")
}

// 根据街道获取小区列表
// 申请类型、单位
const getIntentCommunitys = (streetTown, applyType, companyID) => {
    return get("/api/rent/get_intent_communitys",{streetTown, applyType, companyID})
}

// 根据申请单ID获取小区列表
const getEditCommunitys = (applyID,streetTown) => {
    return get("/api/rent/get_edit_communitys",{applyID,streetTown})
}

//公司文章大分类
const getSubmoduleList = (ModuleType) => {
    return get("/api/portal/get_submodule_list",{ModuleType:ModuleType})
}

//公司文章小分类（SubModuleType为0的，不需要调用此接口；直接调用getArticleContent获取文章详细）
const getArticleListBySubmoduletype = (SubModuleType,SubModuleID,PageIndex,PageSize) => {
    return get("/api/portal/get_article_list_by_submoduletype",{SubModuleType:SubModuleType,SubModuleID:SubModuleID,PageIndex:PageIndex,PageSize:PageSize})
}

//公司文章内容
const getArticleContent = (ArticleID) => {
    return get("/api/portal/get_article_content",{ArticleID:ArticleID})
}

//公示信息
const getPublicyInfo = () => {
    return get("/api/portal/get_pubilcy_info")
}

//公示信息
const getPublicyWaitingInfo = () => {
    return get("/api/portal/get_pubilcy_waiting_info")
}

// 咨询服务展示
const getComplainList = (pageIndex,pageSize)=>{
    return get("/api/portal/get_Complain_list",{pageIndex,pageSize});
}

// 小区查询导航菜单
const getNavInfo = () =>{
    return get("/api/portal/get_nav_list");
}

// 小区详情
const getCommunityDetail = id=>{
    return get("/api/portal/get_community_detail",{id})
}

// 小区图片
const getCommunityPictures = id =>{
    return get("/api/portal/get_community_pictures",{id})
}

// 小区房源类型
const getCommunityRoomKinds = id =>{
    return get("/api/portal/get_community_room_kinds",{id})
}

// 小区房源类型
const getRoomTypeDetail = id =>{
    return get("/api/portal/get_room_type_detail",{id})
}

// 根据小区、申请类别确认户型
const getIntentRoomKinds = (communityID,rentType) =>{
    return get("/api/rent/get_intent_room_kinds",{communityID,rentType})
}

// 咨询投诉
const getConsultContent = (pageIndex,pageSize,type) =>{
    return get("/api/protal/get_consult_list",{pageIndex,pageSize,type})
}

const subConsultContent = (content) => {
    return post("/api/protal/sub_consult_content",content)
}

// 预定看房
const orderSeeHouse = (content) => {
    return post("/api/protal/order_see_house",content)
}

const getBuilding = (communityID) => {
    return get("/api/portal/get_buildings", { communityID })
}


const getPartyBuildList = (pageIndex, pageSize) => {
    return get("/api/aboutus/party_build", { pageIndex, pageSize });
}

const getPartyBuildArticleDetail = (id) => {
    return get("/api/aboutus/party_build_article_detail", { id })
}

const getAboutInfo = (name) => {
    return get("/api/aboutus/party_about_info", { name })
}
// 预定看房中，获取小区及小区下面的户型
// const getCommunityAndRoomKinds = () => {
//     return get("/api/portal/get_all_room_kinds");
// }
// 预定看房中，获取小区及小区下面的户型
const getCommunitysForBooking = (streetTown) =>{
    return get("/api/rent/get_communitys_for_booking", { streetTown })
}

// 判断用户是否 申请过
const judgeUserHasApplied = () => {
    return get("/api/protal/judge_user_has_applied");
}

// 判断用户的申请状态 In 表
const judgeUserHasAppliedStaus = () => {
    return get("/api/protal/judge_user_has_applied_status");
}

// 获取排队人数
const getWaitingNumForPortal = (communityID, roomKindsID, sex) => {
    return post("/api/protal/get_waiting_num_for_portal",{communityID, roomKindsID, sex})
}

export default {
    getBannerImgs,
    getCommunityList,
    getStreetTownList,
    getSubmoduleList,
    getArticleListBySubmoduletype,
    getArticleContent,
    getPublicyInfo,
    getPublicyWaitingInfo,
    getComplainList,
    getNavInfo,
    getCommunityDetail,
    getCommunityPictures,
    getCommunityRoomKinds,
    getRoomTypeDetail,
    getIntentCommunitys,
    getEditCommunitys,
    getIntentRoomKinds,
    getConsultContent,
    subConsultContent,
    orderSeeHouse,
    getBuilding,
    getPartyBuildList,
    getPartyBuildArticleDetail,
    getAboutInfo,
    //getCommunityAndRoomKinds,
    getCommunitysForBooking,
    judgeUserHasApplied,
    judgeUserHasAppliedStaus,
    getWaitingNumForPortal
}